var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotSatisfied(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sad-face",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_585",
    "data-name": "Ellipse 585",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#ffd93b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10524",
    "data-name": "Path 10524",
    d: "M21.329,11.329A10,10,0,0,1,3.545,17.608,10,10,0,0,0,17.608,3.545,9.989,9.989,0,0,1,21.329,11.329Z",
    transform: "translate(-1.329 -1.329)",
    fill: "#f4c534"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10525",
    "data-name": "Path 10525",
    d: "M17.608,12.414a5.908,5.908,0,0,1-4.3-1.719.391.391,0,0,1,.586-.517,5.222,5.222,0,0,0,3.711,1.455.391.391,0,1,1,0,.781Zm-7.26,2.624a7.835,7.835,0,0,1-4.738,1.094,36.867,36.867,0,0,0,3.837-1.587c-.549-.294-1.365-.923-1.35-1.538C8.822,14.014,12.133,13.923,10.349,15.038Zm7.931,1.094c-2.348.271-5.767-1.082-5.119-1.9a8.636,8.636,0,0,1,1.487-.544,2.811,2.811,0,0,0,1.144-.681c.015.616-.8,1.243-1.35,1.538A37.336,37.336,0,0,0,18.28,16.132Zm-12-3.718a.391.391,0,0,1,0-.781,5.223,5.223,0,0,0,3.711-1.455.391.391,0,0,1,.586.517A5.911,5.911,0,0,1,6.281,12.414Zm8.676,6.558a.72.72,0,0,1-.723.723H9.967a.719.719,0,0,1,0-1.439h4.266a.719.719,0,0,1,.723.716Z",
    transform: "translate(-2.104 -3.767)",
    fill: "#3e4347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSatisfied);
export default __webpack_public_path__ + "static/media/not-satisfied.b9134a5a54c35bd931678e027db4dec0.svg";
export { ForwardRef as ReactComponent };